export const fetchPostcodeData = async _ref => {
  let {
    postcode,
    responseKey
  } = _ref;
  try {
    const response = await fetch(`https://api.postcodes.io/postcodes/${postcode}`);
    if (response.ok) {
      const jsonResponse = await response.json();
      const postcodeData = jsonResponse.result;
      if (postcodeData && postcodeData[responseKey]) {
        return {
          success: true,
          data: postcodeData[responseKey]
        };
      } else {
        return {
          success: false,
          data: "We're afraid that postcode is not in the system - please check and try again."
        };
      }
    } else {
      return {
        success: false,
        data: response.status === 404 ? "We're afraid that postcode is not in the system - please check and try again." : 'Something went wrong. Please try again later.'
      };
    }
  } catch (err) {
    return {
      success: false,
      data: 'Something went wrong. Please try again later.'
    };
  }
};